import Swal from "sweetalert2";

const PopupError = (body) => {
  return Swal.fire({
    icon: "error",
    title: "Error!",
    text: body,
    confirmButtonText: "Aceptar",
    confirmButtonColor: "#5373b2",
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
};

export default PopupError;
